const INITIAL_STATE = {
  step: 0,
  reducerUserId: ''
}

export const Creators = {
  resetChallenges: () => ({
    type: 'RESET'
  })
};

export default function stepsReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case 'SET_STEP':
      return {
        ...state,
        step: action.step,
      }
    case 'SET_USER_ID':
      return {
        ...state,
        reducerUserId: action.reducerUserId,
      }
    default:
      return state;
  }
}
